import React, { useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { FaBed, FaHome, FaIdCard, FaUserGraduate } from "react-icons/fa";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/HostelManagement.css";

// Created By Cursor
const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

// Created By Cursor
const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

// Created By Cursor — destinations already used by hostel screens
const HOSTEL_MODULES = [
  {
    id: "hostel-students",
    title: "Hostel Students",
    hint: "List hostel students by class",
    to: "/AdminMain/HostelStudent",
    icon: FaUserGraduate,
    tone: "students",
  },
  {
    id: "hostel-details",
    title: "Student Details",
    hint: "Room, caution money and service months",
    to: "/AdminMain/HostelStudent",
    icon: FaIdCard,
    tone: "details",
  },
];

// Created By Cursor
function HostelTile({ module, index }) {
  const Icon = module.icon;
  return (
    <Link
      to={module.to}
      className={`hm-tile hm-tile--${module.tone}`}
      style={{ "--hm-i": index }}
      aria-label={module.title}
      title={module.hint}
    >
      <span className={`hm-tile__icon hm-tile__icon--${module.tone}`} aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      <span className="hm-tile__body">
        <span className="hm-tile__title">{module.title}</span>
        <span className="hm-tile__hint">{module.hint}</span>
      </span>
    </Link>
  );
}

// Created By Cursor
export default function HostelManagement() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page hm-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Hostel Management</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell hm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaBed />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Hostel Management</h1>
              <p className="sm-hero__sub">
                {HOSTEL_MODULES.length} modules · assign rooms and review hostel
                students
              </p>
            </div>
          </div>
        </header>

        <div className="hm-body">
          <section className="hm-section" aria-labelledby="hm-modules-heading">
            <div className="hm-section__head">
              <h2 id="hm-modules-heading">Hostel modules</h2>
              <p>Open the same destinations used from this hub</p>
            </div>
            <div className="hm-grid">
              {HOSTEL_MODULES.map((module, index) => (
                <HostelTile key={module.id} module={module} index={index} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
